module.exports = __webpack_public_path__ + "static/media/Login.c43eec5d.jpg";